<div class="quick-links-backdrop" *ngIf="showQuickLinks && isAuthenticated" (click)="toggleQuickLinks()"></div>

<div class="quick-links-container" *ngIf="showQuickLinks && isAuthenticated">
  <div class="quick-links-header">
    <div class="header-content">
      <div class="header-icon">
        <mat-icon>bolt</mat-icon>
      </div>
      <div class="header-text">
        <h3>Quick Actions</h3>
        <span class="header-subtitle">Keyboard shortcuts for fast navigation</span>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="toggleQuickLinks()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="quick-links-content">
    <ng-container *ngFor="let link of quickLinks; let i = index">
      <div class="quick-link-item"
           *ngIf="link.key !== '?'"
           (click)="activateQuickLink(link)"
           [style.animation-delay]="(i * 0.06) + 's'">
        <div class="quick-link-key" [style.border-color]="link.color" [style.color]="link.color">
          {{ link.key }}
        </div>
        <div class="quick-link-info">
          <div class="icon-container" [style.background]="link.color + '14'" [style.color]="link.color">
            <mat-icon *ngIf="link.icon">{{ link.icon }}</mat-icon>
          </div>
          <div class="link-text">
            <span class="link-title">{{ link.description }}</span>
            <span class="link-subtitle" *ngIf="getSubtitle(link)">{{ getSubtitle(link) }}</span>
          </div>
        </div>
        <div class="quick-link-arrow" [style.color]="link.color">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="quick-links-footer">
    <div class="footer-content">
      <div class="help-text">
        <span>Press <span class="key">?</span> to toggle</span>
      </div>
      <div class="footer-stats">
        <mat-icon>keyboard</mat-icon>
        <span>{{ quickLinks.length - 1 }} shortcuts</span>
      </div>
    </div>
  </div>
</div>

<div class="quick-links-toggle" *ngIf="!showQuickLinks && isAuthenticated" (click)="toggleQuickLinks()">
  <div class="toggle-icon">
    <mat-icon>bolt</mat-icon>
  </div>
  <div class="toggle-tooltip">Quick Actions</div>
</div>
